module.exports = __webpack_public_path__ + "static/media/tmdb.0f4a7f74.svg";